import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const getAllUsers = SettingsService.returnAllUsersDetailedUsersAllGet

export const getCurrentUser = SettingsService.returnCurrentUserUsersMeGet

export const createUser = SettingsService.createUserUsersCreateUserPost

export const updateUser = SettingsService.editUserUsersEditUpdatePatch

export const userLogin = SettingsService.signinUsersLoginPost

export const userPasswordlessLogin = SettingsService.requestTempPasswordUsersRequestTempPasswordPost
export const internalUserPasswordlessLogin = SettingsService.requestTempPasswordInternalUsersRequestTempPasswordInternalPost

export const loginWithTempPassword = SettingsService.loginWithTempPasswordUsersLoginWithTempPasswordPost

export const getLoginMode = () => SettingsService.getLoginModesUsersLoginModesGet()

export const userLogout = SettingsService.logoutUsersLogoutPost

export const forgotPassword = SettingsService.forgotPasswordUsersForgotPasswordPost

export const validateForgotPassword = SettingsService.validateForgotPasswordUsersValidateForgotPasswordPost;

export const refreshToken = SettingsService.refreshTokenUsersRefreshTokenPost;

export const ssoLogin = SettingsService.ssoLoginUsersSsoLoginGet;

export const ssoTokenGet = SettingsService.ssoTokenUsersSsoTokenGet;

export const ssoValidateEmailPOST = SettingsService.validateUserEmailUsersValidateUserEmailPost;

export const downloadUserBulkUpldTemplate = SettingsService.downloadBulkTemplatesUsersTemplateDownloadGet

export const uploadUserBulkUpldTemplate = SettingsService.uploadBulkUserUsersUploadBulkUserPost

export const getAvailableRolesOfUser = SettingsService.getRolesBelowMeUsersRolesBelowMeGet

export const resetPassword = SettingsService.resetPasswordEndpointUsersResetPasswordPost

export const getAllFilteredUsersByTeams = SettingsService.returnAllTeamsUsersDetailedUsersTeamsUsersAllGet